var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSaved(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25124 1.5C2.07166 1.5 1.88707 1.57614 1.7418 1.73222C1.59479 1.89017 1.50348 2.11553 1.50348 2.36111V13.7268L5.54166 10.6278C5.81187 10.4204 6.18813 10.4204 6.45834 10.6278L10.4965 13.7268V2.36111C10.4965 2.11553 10.4052 1.89017 10.2582 1.73222C10.1129 1.57614 9.92834 1.5 9.74876 1.5H2.25124ZM0.640064 0.711545C1.05722 0.263339 1.63544 0 2.25124 0H9.74876C10.3646 0 10.9428 0.263339 11.3599 0.711545C11.7753 1.15788 12 1.7521 12 2.36111V15.25C12 15.5357 11.8373 15.7966 11.5803 15.9228C11.3234 16.0491 11.0169 16.0187 10.7899 15.8445L6 12.1684L1.21008 15.8445C0.983084 16.0187 0.676589 16.0491 0.419658 15.9228C0.162726 15.7966 0 15.5357 0 15.25V2.36111C0 1.7521 0.224651 1.15788 0.640064 0.711545Z",
    fill: "#484848"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSaved);
export default __webpack_public_path__ + "static/media/iconSaved.173ab271.svg";
export { ForwardRef as ReactComponent };